import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "./ui/navigation-menu";
import { cn } from "../lib/utils";

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header
      style={{ backgroundColor: "var(--color-altBrand)" }}
      className="sticky top-0 z-50 shadow-md"
    >
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
        <img
          src="/images/logo.png"
          alt="Cycle Collective Saskatoon"
          className="h-12 md:h-16"
        />

        {/* Desktop Navigation */}
        <div className="hidden md:block">
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link
                    className={cn(
                      navigationMenuTriggerStyle(),
                      "hover:opacity-70",
                    )}
                    to="/"
                  >
                    HOME
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link
                    className={cn(
                      navigationMenuTriggerStyle(),
                      "hover:opacity-70",
                    )}
                    to="/contact"
                  >
                    CONTACT
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link
                    className={cn(
                      navigationMenuTriggerStyle(),
                      "hover:opacity-70",
                    )}
                    to="/services"
                    prefetch="intent"
                  >
                    MEMBERSHIP
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  {/* Full page navigation so the Mindbody widget script loads fresh */}
                  <a
                    className={cn(
                      navigationMenuTriggerStyle(),
                      "hover:opacity-70",
                    )}
                    href="/schedule"
                  >
                    SCHEDULE
                  </a>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="hover:opacity-70">
                  EXPERIENCE
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                    <li>
                      <NavigationMenuLink asChild>
                        <Link
                          className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          to="/experience/faq"
                        >
                          <div className="text-sm font-medium leading-none">
                            FAQ
                          </div>
                        </Link>
                      </NavigationMenuLink>
                    </li>
                    <li>
                      <NavigationMenuLink asChild>
                        <Link
                          className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          to="/experience/cyclecobasics"
                        >
                          <div className="text-sm font-medium leading-none">
                            CYCLE CO BASICS
                          </div>
                        </Link>
                      </NavigationMenuLink>
                    </li>
                    <li>
                      <NavigationMenuLink asChild>
                        <Link
                          className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                          to="/experience/privacypolicy"
                        >
                          <div className="text-sm font-medium leading-none">
                            PRIVACY POLICY
                          </div>
                        </Link>
                      </NavigationMenuLink>
                    </li>
                  </ul>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          className="md:hidden flex flex-col space-y-1"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span className="block w-6 h-0.5 bg-current"></span>
          <span className="block w-6 h-0.5 bg-current"></span>
          <span className="block w-6 h-0.5 bg-current"></span>
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="container mx-auto px-4 py-4 space-y-4">
            <Link
              to="/"
              className="block py-2 hover:opacity-70"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              HOME
            </Link>
            <Link
              to="/contact"
              className="block py-2 hover:opacity-70"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              CONTACT
            </Link>
            <Link
              to="/services"
              className="block py-2 hover:opacity-70"
              onClick={() => setIsMobileMenuOpen(false)}
              prefetch="intent"
            >
              MEMBERSHIP
            </Link>
            {/* Full page navigation so the Mindbody widget script loads fresh */}
            <a
              href="/schedule"
              className="block py-2 hover:opacity-70"
            >
              SCHEDULE
            </a>
            <div className="space-y-2">
              <div className="font-medium py-2">EXPERIENCE</div>
              <Link
                to="/experience/faq"
                className="block py-1 pl-4 hover:opacity-70"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link
                to="/experience/cyclecobasics"
                className="block py-1 pl-4 hover:opacity-70"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                CYCLE CO BASICS
              </Link>
              <Link
                to="/experience/privacypolicy"
                className="block py-1 pl-4 hover:opacity-70"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                PRIVACY POLICY
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
